import $ from 'jquery'
import imagesLoaded from 'imagesLoaded'
import { TweenLite } from 'gsap'

import '../../node_modules/gsap/src/uncompressed/plugins/ScrollToPlugin.js'
import '../../node_modules/slick-carousel/slick/slick.min.js'

import WOW from 'wowjs'

new WOW.WOW({
	offset: window.innerHeight * 0.1
}).init();

// var Parsley = require('parsleyjs');
// var Hammer = require('hammerjs');

/*!
 * The Final Countdown for jQuery v2.2.0 (http://hilios.github.io/jQuery.countdown/)
 * Copyright (c) 2016 Edson Hilios
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
!function(a){"use strict";"function"==typeof define&&define.amd?define(["jquery"],a):a(jQuery)}(function(a){"use strict";function b(a){if(a instanceof Date)return a;if(String(a).match(g))return String(a).match(/^[0-9]*$/)&&(a=Number(a)),String(a).match(/\-/)&&(a=String(a).replace(/\-/g,"/")),new Date(a);throw new Error("Couldn't cast `"+a+"` to a date object.")}function c(a){var b=a.toString().replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1");return new RegExp(b)}function d(a){return function(b){var d=b.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);if(d)for(var f=0,g=d.length;f<g;++f){var h=d[f].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),j=c(h[0]),k=h[1]||"",l=h[3]||"",m=null;h=h[2],i.hasOwnProperty(h)&&(m=i[h],m=Number(a[m])),null!==m&&("!"===k&&(m=e(l,m)),""===k&&m<10&&(m="0"+m.toString()),b=b.replace(j,m.toString()))}return b=b.replace(/%%/,"%")}}function e(a,b){var c="s",d="";return a&&(a=a.replace(/(:|;|\s)/gi,"").split(/\,/),1===a.length?c=a[0]:(d=a[0],c=a[1])),Math.abs(b)>1?c:d}var f=[],g=[],h={precision:100,elapse:!1,defer:!1};g.push(/^[0-9]*$/.source),g.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),g.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),g=new RegExp(g.join("|"));var i={Y:"years",m:"months",n:"daysToMonth",d:"daysToWeek",w:"weeks",W:"weeksToMonth",H:"hours",M:"minutes",S:"seconds",D:"totalDays",I:"totalHours",N:"totalMinutes",T:"totalSeconds"},j=function(b,c,d){this.el=b,this.$el=a(b),this.interval=null,this.offset={},this.options=a.extend({},h),this.instanceNumber=f.length,f.push(this),this.$el.data("countdown-instance",this.instanceNumber),d&&("function"==typeof d?(this.$el.on("update.countdown",d),this.$el.on("stoped.countdown",d),this.$el.on("finish.countdown",d)):this.options=a.extend({},h,d)),this.setFinalDate(c),this.options.defer===!1&&this.start()};a.extend(j.prototype,{start:function(){null!==this.interval&&clearInterval(this.interval);var a=this;this.update(),this.interval=setInterval(function(){a.update.call(a)},this.options.precision)},stop:function(){clearInterval(this.interval),this.interval=null,this.dispatchEvent("stoped")},toggle:function(){this.interval?this.stop():this.start()},pause:function(){this.stop()},resume:function(){this.start()},remove:function(){this.stop.call(this),f[this.instanceNumber]=null,delete this.$el.data().countdownInstance},setFinalDate:function(a){this.finalDate=b(a)},update:function(){if(0===this.$el.closest("html").length)return void this.remove();var b,c=void 0!==a._data(this.el,"events"),d=new Date;b=this.finalDate.getTime()-d.getTime(),b=Math.ceil(b/1e3),b=!this.options.elapse&&b<0?0:Math.abs(b),this.totalSecsLeft!==b&&c&&(this.totalSecsLeft=b,this.elapsed=d>=this.finalDate,this.offset={seconds:this.totalSecsLeft%60,minutes:Math.floor(this.totalSecsLeft/60)%60,hours:Math.floor(this.totalSecsLeft/60/60)%24,days:Math.floor(this.totalSecsLeft/60/60/24)%7,daysToWeek:Math.floor(this.totalSecsLeft/60/60/24)%7,daysToMonth:Math.floor(this.totalSecsLeft/60/60/24%30.4368),weeks:Math.floor(this.totalSecsLeft/60/60/24/7),weeksToMonth:Math.floor(this.totalSecsLeft/60/60/24/7)%4,months:Math.floor(this.totalSecsLeft/60/60/24/30.4368),years:Math.abs(this.finalDate.getFullYear()-d.getFullYear()),totalDays:Math.floor(this.totalSecsLeft/60/60/24),totalHours:Math.floor(this.totalSecsLeft/60/60),totalMinutes:Math.floor(this.totalSecsLeft/60),totalSeconds:this.totalSecsLeft},this.options.elapse||0!==this.totalSecsLeft?this.dispatchEvent("update"):(this.stop(),this.dispatchEvent("finish")))},dispatchEvent:function(b){var c=a.Event(b+".countdown");c.finalDate=this.finalDate,c.elapsed=this.elapsed,c.offset=a.extend({},this.offset),c.strftime=d(this.offset),this.$el.trigger(c)}}),a.fn.countdown=function(){var b=Array.prototype.slice.call(arguments,0);return this.each(function(){var c=a(this).data("countdown-instance");if(void 0!==c){var d=f[c],e=b[0];j.prototype.hasOwnProperty(e)?d[e].apply(d,b.slice(1)):null===String(e).match(/^[$A-Z_][0-9A-Z_$]*$/i)?(d.setFinalDate.call(d,e),d.start()):a.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi,e))}else new j(this,b[0],b[1])})}});

String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

window.app = {
	W: $(window).width(),
	H: $(window).height(),

	scrollTop: $(window).scrollTop(),
	isMobileNavOpen: false,
	isHome: $('body.home').length > 0,

	sliderInstance: {},

	init: function() {

		var _this = this;

		_this.wrapTitle();

		_this.setupEvents();
		_this.preload([]);

		_this.initWOW();

		$('.slider').slick({
			autoplay: true,
			speed: 600,
			autoplaySpeed: 5500,
			fade: false,
			dots: true,
			accessibility: false,
			pauseOnHover: false,
			pauseOnDotsHover: true,
			arrows : false
		});

		$('.slider').on('init', function(slick) {
			$('.slick-active').find('.slider-content').addClass('animate')
		});

		$('.slider').on('afterChange', function(event, slick, currentSlide, nextSlide) {
			$('.slider-content').removeClass('animate')
		 	$('.slick-active').find('.slider-content').addClass('animate')
		});

		$('.page-course-offerSwitch button').first().trigger('click')
	},

	setupEvents: function() {
		var _this = this;

		$('form').on('click', '.button', function(event) {
			event.preventDefault();
			$(this).submit();
		});

		$('form').on('submit', function(event) {
			event.preventDefault();

			var $this = $(this),
				action = $(this).attr('action'),
				data = $(this).serialize(),
				formId = $this.attr('id'),
				$rowMessage = $('.row-message');

			action = action.replace('_submit', '');
				
			if (!_this.isCaptcha()) {
				return false
			}

		    $.ajax({
		      url: action,
		      type: 'POST',
		      cache: false,
		      data: data,

		      beforeSend: function() {
		      	$rowMessage.addClass('hidden')
				$('.row-submit').addClass('hidden')
				$('.row-preloader').removeClass('hidden')
		      },

		      success : function(res) {
		        res = JSON.parse(res)
		        $('.row-preloader').addClass('hidden')

		        if (formId == 'request' && window.gtag) {
		        	var url = undefined
		        	var coursePrice = 1000.0

		        	if ($('#coursePrice').length > 0) {
		        		coursePrice = parseInt($('#coursePrice').get(0).value)
		        	}

				    var callback = function () {
				    	if (typeof(url) != 'undefined') {
				    		window.location = url;
				    	}
				    };

				    window.gtag('event', 'Formularz - zapis na kurs', {
				      event_category: 'Formularz - zapis na kurs',
				      event_label: 'Formularz - zapis na kurs'
				    })

				    window.gtag('event', 'conversion', {
				    	'send_to': 'AW-739777115/1V9zCPz43Z8BENu04OAC',
				    	'value': coursePrice,
				    	'currency': 'PLN',
				    	'event_callback': callback
				    });

	        		console.log(coursePrice)
	        		console.log('** kod google **')

		        } else {
				    window.gtag('event', 'Formularz - kontakt', {
				      event_category: 'Formularz - kontakt',
				      event_label: 'Formularz - kontakt'
				    })
		        }

		        if (res.status == true) {
		        	var successHTML = $rowMessage.find('.success').html()

		        	$rowMessage.removeClass('hidden')
		        	$rowMessage.find('.error').addClass('hidden')

		        	if ($('#name').get(0).value == '') {
		        		$rowMessage.find('.success').html( successHTML.replace('{name}', '') )
		        	} else {
						$rowMessage.find('.success').html( successHTML.replace('{name}', $('#name').get(0).value) )
		        	}

		        	$('.form-body').remove()
		        	
		        	$rowMessage.find('.success').removeClass('hidden')

		        	_this.scrollTo({
		        		pos: $rowMessage.parent().parent().offset().top
		        	})
		        }

		        if (res.status == false) {
		        	$rowMessage.removeClass('hidden')
		        	$rowMessage.find('.error').removeClass('hidden')
		        	$rowMessage.find('.success').addClass('hidden')
		        	$('.row-submit').removeClass('hidden')

		        	setTimeout(function() {
						$rowMessage.addClass('hidden')
		        	}, 3000)
		        }
		      }
		    })
		});

		$('.page-course-offerSwitch button').on('click', function(event) {
			event.preventDefault();
			$('.page-course-offerSwitch li').removeClass('active')
			$(this).parent().addClass('active')
			$('.page-course-offerTab').removeClass('active')
			$('#' + $(this).data('for')).addClass('active')

			var price = $('.page-course-offerTab.active').find('.page-course-priceValue').html();
			price = price.replaceAll(' ', '')
			price = price.replaceAll('&nbsp;', ' ')
			price = price.replaceAll('	', '')

			$('#coursePrice').val( price )
			$('#courseType').val( $(this).html() )
			$('.page-course-offerTab.active').find('.page-course-dates button').first().trigger('click')
		});

		$('.page-course-dates button').on('click', function(event) {
			event.preventDefault();
			
			$('.page-course-dates li').removeClass('active')
			$(this).parent().addClass('active')

			$('#courseDate').val( $(this).find('.dateText').html() )
		});

		$('.header-navTrigger a').click(function(event) {
			event.preventDefault()
			_this.toggleMobileNav()
		});

		$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]').on('click', function(event) {
			event.preventDefault();
			var target = $(this.hash);
	        event.preventDefault();

	        if (this.hash == '#regulamin') {
	        	$("#regulamin").removeClass('inactive')
	        }

	        _this.scrollTo({
	        	pos: target.offset().top
	        });
		});

		$(window).on('resize', function(event) {
			event.preventDefault()
			_this.onResize()
		});

		$(window).on('scroll', function(event) {
			_this.onScroll();
		});
	},

	onResize: function() {
		app.W = window,innerWidth
		app.H = window,innerHeight
		this.adjustCoursesHeight()
	},

	onScroll: function() {
		app.scrollTop = $(window).scrollTop()
	},

	scrollToTop: function() {
		if ($(window).scrollTop() > 0) {
			this.scrollTo({
				pos: 0, 
				speed: 0.4
			});
		}
	},

	initWOW: function() {

	},

	wrapTitle: function() {
		var $title = $('.page-course-titleText');
		if ($title.length > 0) {
			var content = $title.html()
			var contentArr = content.split(' ');
			var html = ''

			if (contentArr.length > 2)  {
				$.each(contentArr, function(index, item) {
					if (index == contentArr.length - 1) {
						html += "<span class='lastSpan'><span class='text'>" + item + "</span></span>"
					} else if (index == contentArr.length - 2) {
						html += item + '<br/>'
					} else {
						html += item + ' '
					}
				})
			} else {
				html += "<span class='lastSpan'><span class='text'>" + contentArr[0] + ' ' + (contentArr[1] ? contentArr[1] : '') + "</span></span>"
			}

			$title.html(html)

			console.log(contentArr)
		}
	},

	adjustCoursesHeight: function() {
		var $courses = $('.single-course');
		var max = 0

		$courses.each(function(index, el) {
			var $this = $(this);

			$this.css('min-height', '')

			if (max < $this.outerHeight()) {
				max = $this.outerHeight()
				if (max%2 == 1) max = max + 1
			}
		});

		$courses.each(function(index, el) {
			var $this = $(this)

			$this.css('min-height', app.W < 767 ? '' : max)
			$this.addClass('active')
		});
	},

	toggleMobileNav: function() {
		var $header = $('header'),
			$nav = $('.header-navTrigger'),
			$pageContent = $('.page-content');

		if ($header.hasClass('active')) {
			$header.removeClass('active');
			// $pageContent.removeClass('mask');
			$header.removeClass('active');
			$nav.removeClass('active');
		} else {
			$header.addClass('active');
			// $pageContent.addClass('mask');
			$nav.addClass('active');
		}

	},

	scrollTo: function(params) {
		if (params.pos == undefined) {params.pos = 0};
		if (params.speed == undefined) {params.speed = 0.8};

		TweenLite.to( window, params.speed, {
			scrollTo: {
				y: params.pos - $('.header').height() - 10
			},
			ease: Cubic.EaseIn
		});
	},

	showHideMobileNav: function(param) {
		var $header = $('header'),
			$nav = $('.header-mobileNav-trigger'),
			param = param || {};
			// $pageContent = $('.page-content');

		if (app.isMobileNavOpen || param.hide == true) {
			$header.removeClass('active');
			$nav.removeClass('active');
			app.isMobileNavOpen = false
		} else {
			$header.addClass('active');
			$nav.addClass('active');
			app.isMobileNavOpen = true
		}
	},

	preload: function(images) {

		var $body = $('body'),
			_this = this;

		if (images) {
			$.each(images, function(index, val) {
				$body.find('.footer').append('<img class="preloading" src=" ' + val +' ">');
			});
		}

		imagesLoaded( 'body', { background: true }, function() {
			$body.find('.preloading').each(function(index, el) {
				$(this).remove()
			});

			$body.removeClass('loading')

			var footerMail = $('.footer-contactMail').next().find('strong').html();
			var footerMailHref = $('.footer-contactMail').parent().attr('href')

			$('.footer-contactMail').next().find('strong').html( footerMail.replace('super_', '') )
			$('.footer-contactMail').parent().attr('href', footerMailHref.replace('super_', ''))
			
			setTimeout(function() {
				_this.adjustCoursesHeight()
			}, 500);
		});
	},

	isCaptcha: function() {
		var captcha_code = window.grecaptcha.getResponse();
		var is_valid = captcha_code !== '' ? true : false;

		if (!is_valid) {
			$('.captchaHolder-error').removeClass('hidden');
		} else {
			$('.captchaHolder-error').addClass('hidden');
		}
		
		return is_valid;
	}
};

$(document).ready(function() {
	window.app.init();
	window.captchaLoadCallback = window.app.isCaptcha;
});